module.exports = __webpack_public_path__ + "kudos_28.svg?1aa092acb0ad1dd09519086194e8ebb0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_28.svg
// module id = 126
// module chunks = 0